import { createApp } from 'vue'
import App from './App.vue'

import router from './router'
import 'vant/lib/index.css';
import 'amfe-flexible'
import Header from './components/Header.vue'
import TabBar from './components/TabBar.vue'

import { Progress, Circle, Tabbar, TabbarItem, Popup, NavBar, Tab, Tabs, Popover, Button } from 'vant'
import i18n from './i18n'

const app = createApp(App)
app.use(router)
app.use(i18n)
app.component('Header', Header)
app.component('TabBar', TabBar)
app.use(Progress).use(Circle).use(Tabbar).use(TabbarItem).use(Popup).use(NavBar).use(Tab).use(Tabs)
.use(Popover).use(Button)
app.mount('#app')
